import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { tokens } from '../../../../../theme';

const SectionStepper = ({ sections, currentIndex, onNavigate, answers }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box sx={{ display: 'flex', gap: 1, overflowX: 'auto', px: 1 }}>
            {sections.map((section, idx) => {
                const isCurrent = idx === currentIndex;
                const questions = section.v2_test_questions || [];
                const answeredCount = questions.filter(q => {
                    const ans = answers.get(q.id);
                    return ans?.answer_text?.trim();
                }).length;
                const allDone = answeredCount === questions.length && questions.length > 0;

                return (
                    <Box
                        key={section.id || idx}
                        onClick={() => onNavigate(idx)}
                        sx={{
                            cursor: 'pointer',
                            px: 1.5, py: 0.5,
                            borderRadius: 1,
                            minWidth: 'fit-content',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 0.75,
                            border: '1px solid',
                            borderColor: isCurrent ? colors.blueAccent[400] : colors.grey[700],
                            bgcolor: isCurrent ? `${colors.blueAccent[400]}15` : 'transparent',
                            transition: 'all 0.15s',
                            '&:hover': { borderColor: colors.blueAccent[400] },
                        }}
                    >
                        <Typography variant="body2" fontWeight={isCurrent ? 600 : 400} noWrap>
                            {section.section_name || `Section ${idx + 1}`}
                        </Typography>
                        {allDone ? (
                            <CheckCircleOutlineIcon sx={{ fontSize: 16, color: 'success.main' }} />
                        ) : (
                            <Typography variant="caption" color="text.secondary" noWrap>
                                {answeredCount}/{questions.length}
                            </Typography>
                        )}
                    </Box>
                );
            })}
        </Box>
    );
};

export default SectionStepper;
